let intialState = {
    sideMenuList: [],
    isSuggestion: false
}

export default function sideBarReducer(state = intialState, action) {
    let stateCopy = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case 'Get_Side_Menu_List':
            stateCopy.sideMenuList = action.payload.map(item => ({ ...item, id: item.action }));
            // Add Home to sidebar only on mobile for student and lne_student roles
            const role = localStorage.getItem('role');
            const isMobile = window.innerWidth <= 767;
            if (isMobile && (role === 'student' || role === 'lne_student')) {
                const homeItem = { action: 'home', icon: 'home-layout-icon.svg', text: 'Home', id: 'home' };
                stateCopy.sideMenuList = [homeItem, ...stateCopy.sideMenuList];
            }
            if (
                (role === 'faculty' || role === 'lne_faculty' || role === 'faculty_incharge' || role === 'lne_faculty_incharge' || role === 'corporate_faculty') &&
                !stateCopy.sideMenuList.some(item => item.action === 'faculty-content')
            ) {
                const afterMyContent = stateCopy.sideMenuList.findIndex(item => item.action === 'my-content');
                const facultyContentItem = {
                    action: 'faculty-content',
                    icon: 'faculty-layout-icon.svg',
                    text: 'Faculty Content',
                    id: 'faculty-content'
                };
                if (afterMyContent >= 0) {
                    stateCopy.sideMenuList.splice(afterMyContent + 1, 0, facultyContentItem);
                } else {
                    stateCopy.sideMenuList.push(facultyContentItem);
                }
            }
            return stateCopy;
        case 'Get_Student_Details':
            stateCopy.studentDetails = action.payload;
            localStorage.setItem('center', action.payload.center_id)
            return stateCopy;
        case 'Get_Popup_Notifications':
            stateCopy.notifications = action.payload.data;
            stateCopy.unread = action.payload.unread;
            return stateCopy;
        case 'Marked_Notification':
            window.location.href = action.payload;
            return stateCopy;
        case 'Get_Profile_Details':
            stateCopy.profileDetails = action.payload;
            localStorage.setItem('id', stateCopy.profileDetails._id);
            localStorage.setItem('role', stateCopy.profileDetails?.role);
            return stateCopy;
        case 'Intro_Complete':
            localStorage.setItem("introComplete", JSON.stringify(true));
            return stateCopy;
        case 'Get_Suggestions':
            stateCopy.suggestions = action.payload;
            return stateCopy;
        case 'Open_Suggestion':
            stateCopy.isSuggestion = true;
            return stateCopy;
        case 'Close_Suggestion':
            stateCopy.isSuggestion = false;
            return stateCopy;
        case 'Logout_Done':
            return stateCopy
        default:
            return stateCopy;

    }
}